<template>
  <v-app>
    <form>
      <v-card>
        <v-card-title>
          <span class="headline" v-if="!service.id">New service</span>
          <v-layout v-else column ma-0>
            <span class="headline">Edit "{{ service.name }}"</span>
            <span style="font-size: 16px">{{ service.id }}</span>
          </v-layout>
          <v-spacer></v-spacer>
          <v-btn text icon @click="hideModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Service Name*"
                  v-model.trim="service.name"
                  v-validate="'required'"
                  :error-messages="errors.collect('service name')"
                  data-vv-name="service name"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Code*"
                  hint="Will always be converted to lowercase"
                  :disabled="service.id && service.id !== ''"
                  v-model.trim="service.code"
                  v-validate="'required|alpha_dash|min:4|max:50'"
                  :error-messages="errors.collect('code')"
                  data-vv-name="code"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Group*"
                  v-model.trim="service.group"
                  v-validate="'required'"
                  :error-messages="errors.collect('group')"
                  data-vv-name="group"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <small>*indicates required field</small>
          <v-spacer></v-spacer>
          <v-btn text @click="hideModal">Close</v-btn>
          <v-btn color="success" outlined @click="saveService">Save</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-app>
</template>

<script>
import fb from "@/firebase";
import { mapMutations } from "vuex";

const services = fb.db.collection("service_profiles");

export default {
  name: "ServiceForm",
  components: {},
  props: {
    service: Object
  },
  data: () => ({
    loading: false
  }),
  computed: {},
  firestore: {
    services: services
  },
  watch: {
    service: {
      handler: function(val) {
        if (val.services) {
          this.selectedServices = val.services;
        } else {
          this.selectedServices = [];
        }
      },
      immediate: true
    }
  },
  mounted: function() {},
  methods: {
    ...mapMutations(["setAppAlert"]),
    remove(item) {
      const index = this.selectedServices.indexOf(item.value);
      if (index >= 0) this.selectedServices.splice(index, 1);
    },
    saveService: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.service.created = this.service.created
            ? this.service.created
            : Date.now();
          this.service.code = this.service.code.toLowerCase();
          if (!this.service.id) {
            services
              .add(this.service)
              .then(() => {
                this.setAppAlert({
                  visible: true,
                  text: "The service has been created",
                  color: "success"
                });
                this.hideModal();
              })
              .catch(error => {
                this.setAppAlert({
                  visible: true,
                  text: error.message
                });
              });
          } else {
            services
              .doc(this.service.id)
              .update(this.service)
              .then(() => {
                this.setAppAlert({
                  visible: true,
                  text: "The service has been updated",
                  color: "success"
                });
                this.hideModal();
              })
              .catch(error => {
                this.setAppAlert({
                  visible: true,
                  text: error.message
                });
              });
          }
          return;
        } else {
          this.setAppAlert({
            visible: true,
            text: "Some required fields are incomplete or invalid",
            color: "error"
          });
        }
      });
    },
    hideModal() {
      //this.offer.name = "";
      //this.offer.frontChannelId = "";
      this.$emit("close");
    }
  }
};
</script>

<style></style>
